import { render, staticRenderFns } from "./Grafica8.vue?vue&type=template&id=3ed2e51a&"
import script from "./Grafica8.vue?vue&type=script&lang=js&"
export * from "./Grafica8.vue?vue&type=script&lang=js&"
import style0 from "./Grafica8.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports